import { isDefinedString, reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import {
  TGetKhattabaClients,
  TSelectionPages,
  TalkhattabatConversationType
} from "../../Types";
import getCoreUIStore from "../core/core-ui-store";
import getCorePopUpStore from "../core/core-popup-store";
import { apiCallGetConversations } from "../../api/khattbat-api/api-call-get-conversations";
import getKhattabat101CStore from "./101c-stores/index";
import getKhattabat102Store from "./102-stores";
import getKhattabat101MatchStore from "./101m-stores";
import getKhattabat101CMessagingStore from "./101c-stores/101c-messaging-store";
import getKhattabat101MMessagingStore from "./101m-stores/101m-messaging-store";
import getKhattabat101CGeneralStore from "./101c-stores/101c-general-store";

class KhattabatStore {
  alkhattabaUUID = observable.box<string>("");

  updateAlkhattabaUUID = (clients: TGetKhattabaClients[]) => {
    const alkhattabaUUID = reduce(() => clients[0].alkhattabaUUID, "");
    this.setAlkhattabaUUID(alkhattabaUUID);
  };
  setAlkhattabaUUID = (alkhattabaUUID: string) => {
    if (!isDefinedString(alkhattabaUUID)) {
      return;
    }
    runInAction(() => {
      this.alkhattabaUUID.set(alkhattabaUUID);
    });
  };

  getOneOOneConversationsId = ({ userUUID }: { userUUID: string }) => {
    const reducedAlkhattabaUUid = this.alkhattabaUUID.get();

    const reducedUserUUid = reduce(() => userUUID, "");
    const clientConversationsId = `${reducedAlkhattabaUUid}_${reducedUserUUid}`;
    return clientConversationsId;
  };

  updateOpenedClientConversation = async () => {
    for (const userID of getKhattabat101CGeneralStore().getCurrentUserIds()) {
      if (getKhattabat101CStore(userID).shouldShowConversation.get()) {
        await this.getClientConversation({ userID, shouldLoad: false });
      }
    }
  };

  getClientConversation = async ({
    userID,
    shouldLoad
  }: {
    userID: number;
    shouldLoad: boolean;
  }) => {
    const client101CStore = getKhattabat101CStore(userID);
    getCoreUIStore().setIsLoading("KHATTABAT_CLIENTS", shouldLoad);
    const { status, code, data } = await apiCallGetConversations(userID);
    getCoreUIStore().setIsLoading("KHATTABAT_CLIENTS", false);
    if (status === "OK") {
      client101CStore.updateClientConversation({ clientConversation: data });
      const oneOTwoMessages = reduce(() => data.oneOTwoMessages, {});
      Object.keys(oneOTwoMessages).forEach((oneOTwoConversationId) => {
        getKhattabat102Store(oneOTwoConversationId).setOneOTwoConversationData({
          data: oneOTwoMessages[oneOTwoConversationId],
          userID
        });
      });
      return;
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  getOneOOneUserUUID = ({
    userID,
    conversationType
  }: {
    userID: number;
    conversationType: TalkhattabatConversationType;
  }) => {
    return conversationType === "101M" || conversationType === "101M_COMMENTS"
      ? getKhattabat101MatchStore(userID).matchUUID.get()
      : getKhattabat101CStore(userID).userUUID.get();
  };

  setOneOOneMessagesSeen = async ({
    userID,
    pageType
  }: {
    userID: number;
    pageType: TSelectionPages;
  }) => {
    if (pageType === "clientPage") {
      return getKhattabat101CMessagingStore(userID).markMessagesSeen();
    }
    return getKhattabat101MMessagingStore(userID).markMessagesSeen();
  };
}

const getKhattabatStore = memoize(
  () => new KhattabatStore(),
  () => 1
);
export default getKhattabatStore;
